// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8bdc2653","977":"9dd478a3"}[chunkId] + ".chunk.js";
};